<template>
<booking-section id="flight-results" :title="sectionTitle" :collapsed="moduleCollapsed"@section-clicked="sectionClicked">
<div v-if="loaded">

<div id="flight-plan-overlay" class="reveal" data-reveal="">
  <loader v-if="flightPlanLoading" title="Flugplan wird geladen" details="Einen Moment bitte"></loader>

  <div class="flight-plan-inner"></div>
  <button class="close-button" data-close="" type="button">Fenster schließen ( x )</button>
</div>

<div class="filter--main filter--inline spacer-small controlled fadeIn animationEnd" data-animation="fadeIn" v-if="!moduleCollapsed">
<div class="expanded row">
<div class="column expanded row align-spaced filter--main__option__wrapper">



<div class="small-12 medium-expand column filter--main__option"  id="optionsFilter">
  <div class="row"  @click="toggleFilterItem('optionsFilter')">
    <div class="filter--main__option__title">
      <label>Optionen</label>
      <div class="filter--main__option__value" v-html="formattedFilterDisplayOptions()"></div>
    </div>
    <div class="arrow"></div>
  </div>
    <div class="filter--main__option__dropdown">
      <div class="expanded row align-middle spacer-small">
      <label>Flugklassen</label>

        <div class="flight-filter-checkboxes row ">
          <div v-bind:class="`flight-filter-checkbox column small-12 flight-filter--${!carrierAirportFilterSelected('cabin_type', cabin)}`" v-for="cabin in cabinTypes" @click="toggleCarrierAirportFilter('cabin_type', cabin)" >
            <div class="checkbox-icon"><span class="checkbox-icon--marker">X</span></div>
            <div class="checkbox-label">{{ cabin }} </div>
          </div>
      </div>

      <div class="column small-12">
        <label>max: Stops</label>
        <vue-slider v-model="flightFilter.stops" :min="0" :max="2" :tooltip="'always'" :tooltip-placement="'bottom'" :tooltip-formatter="sliderStopsFormatter"></vue-slider>
      </div>
    </div>
  </div>
</div>
<div class="filter--main__border"></div>



<div class="small-12 medium-expand column filter--main__option"  id="airlineAirport">
<div class="row"  @click="toggleFilterItem('airlineAirport')">

<div>
<label>Airlines/Airports</label>
<div class="filter--main__option__value" v-html="formattedFilterDisplayAirlineAirport()"></div>
</div>
<div class="arrow"></div>
</div>
<div class="filter--main__option__dropdown">
<div class="expanded row">
  <div class="column small-12">
    <label>Airlines</label>
    <div class="airline-filter-icons">
      <div class="airline-filter-icon" v-bind:class="`airline-filter-icon airline-filter--${!carrierAirportFilterSelected('carrier', carrier.code)}`" v-for="carrier in availableCarriers" @click="toggleCarrierAirportFilter('carrier', carrier.code, carrier.name)">
        <span v-html="carrier.logo"></span>
      </div>
    </div>
  </div>
  <div class="column small-12">
    <label>Umsteige-Airports</label>
    <div class="flight-filter-checkboxes">
      <div v-bind:class="`flight-filter-checkbox flight-filter--${!carrierAirportFilterSelected('airport', airport.code)}`" v-for="airport in availableAirports" @click="toggleCarrierAirportFilter('airport', airport.code, airport.name)" >
        <div class="checkbox-icon"><span class="checkbox-icon--marker">X</span></div>
        <div class="checkbox-label">{{ airport.name}} </div>
      </div>
    </div>
  </div>
</div>
</div>
</div>
<div class="filter--main__border"></div>

<div class="small-12 medium-expand column filter--main__option" id="flightTime" @click="toggleFilterItem('flightTime')">
<div class="row">

<div>
<label>Flugzeit/Dauer:</label>
<div class="filter--main__option__value" v-html="formattedFilterDisplayFlightTime()"></div>
</div>
<div class="arrow"></div>
</div>
<div class="filter--main__option__dropdown">
<div class="expanded row align-middle spacer-small">

  <div class="column small-12 spacer">
    <label>Abflugzeit Anreise</label>
    <vue-slider v-model="flightFilter.departure_hour_out" :min="0" :max="24" :tooltip="'always'" :tooltip-placement="'bottom'" :tooltip-formatter="sliderTimeFormatter"></vue-slider>
  </div>
  <div class="column small-12 spacer">
    <label>Abflugzeit Abreise</label>
    <vue-slider v-model="flightFilter.departure_hour_in" :min="0" :max="24" :tooltip="'always'" :tooltip-placement="'bottom'" :tooltip-formatter="sliderTimeFormatter"></vue-slider>
  </div>
  <div class="column small-12">
    <label>max. Flugdauer / h </label>
    <vue-slider v-model="flightFilter.flight_hours" :min="minFlightHours" :max="maxFlightHours" :tooltip="'always'" :tooltip-placement="'bottom'" :tooltip-formatter="sliderHourFormatter"></vue-slider>
  </div>

</div>
</div>
</div>



<div class="filter--main__border" v-if="anyFiltersSet"></div>
<div class="small-12 medium-expand column filter--main__option"  v-if="anyFiltersSet" id="filterReset">
  <div class="row">
    <div>
      <a class="cta" @click="resetFilter()">
        <i class="foundicon-remove"></i> Filter löschen
      </a>
    </div>
  </div>
</div>


</div>
</div>
</div>

<div class="booking__flight__select__wrapper" style="display: block;">
<div class="booking__flight__select row">
  <div v-bind:class="`column small-12 medium-6 booking__flight__select__option ${(flightFilter.sortOption == 'flight_hours')}`" @click="setSortOption('flight_hours')">
    <div class="booking__flight__select__option__title">
      <img src="/images/icons_svg/checkbox-icon.svg" class="" v-if="flightFilter.sortOption == 'flight_hours'"></img>
      Schnellste
    </div>
    <div class="booking__flight__select__option__price text-xsmall">ab {{result.fastest_price_pp_euro}} EUR p.P.</div>
  </div>
  <div v-bind:class="`column small-12 medium-6 booking__flight__select__option last ${(flightFilter.sortOption == 'price_factor')}`" @click="setSortOption('price_factor')">
    <div class="booking__flight__select__option__title">
      <img src="/images/icons_svg/checkbox-icon.svg" class="" v-if="flightFilter.sortOption == 'price_factor'"></img>
      Günstigste
    </div>
    <div class="booking__flight__select__option__price text-xsmall">ab {{result.cheapest_price_pp_euro}} EUR p.P.</div>
  </div>

</div>
</div>

<div class="booking__flight" id="flight-package-results">
  <div class="row booking-element" :class="{'is-preferred': result.flight_meta.preferred }" v-for="(result) in sortedFlightResults">
    <div class="column small-12 medium-12 large-12 flight-preferred-bar" v-if="result.flight_meta.preferred">LUXURY DREAMS EMPFEHLUNG</div>
    <div class="column small-12 medium-12 large-12">
      <flight-result :flightResult="result.flight_meta" @show-flight-plan="showFlightPlan(result)"></flight-result>
    </div>


    <div class="column small-12 large-8 booking__flight__price text-xsmall">
      <div v-for="sub_price in result.sub_results" class="spacer-small">
        Preis p.P.: ca.
        <b>{{ sub_price.price_display }}</b>
        inkl. Aufenthalt, Flug mit {{ sub_price.free_bags }} und weitere Leistungen<sup>*</sup>
        <div class="small metainfo">{{sub_price.name}}</div>
      </div>
    </div>
    
    <div class="column small-12 large-4">
      <div class="text-right">
        <a class="cta btn btn-info btn-xs" @click="proceedBooking(result)">
          <img src="/images/icons_svg/flight-icon.svg" class="svg-icon"></img>
          Buchen: <b>{{ result.total }}</b>
        </a>
      </div>
      <div class="spacer-small text-right">
        <br /><span class="metainfo text-xsmall">Gesamtpreis für alle Personen inkl. aller Leistungen</span>
      </div>
    </div>

  </div>
</div>
</div>
<loader v-else title="Ihre Flugauswahl wird geladen" details="Einen Moment bitte"></loader>
</booking-section>


</template>

<script>

import axios from 'axios'
import resultLoader from '../booking/mixins/resultLoader'
import bookingDefaults from '../booking/mixins/bookingDefaults'

export default {
  mixins: [resultLoader, bookingDefaults],
  components: {
    flightResult: () => import('../booking/components/flightResult.vue')
  },
  props: {
    isVpMode: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    resultData: {
      handler(res){
        // getting min and max flight hours and other filter value limits
        this.setFlightFilterValues(res)

        this.initialFilter = this._.cloneDeep(this.flightFilter)
        // setting initial values for filteredResults
        this.filteredFlightResults = this._.cloneDeep(res).sort((a,b) => this.flightSortValue(a,b))
      }
    },
    flightFilter: {
      handler(oldFilter, newFilter){

        var tempResult = []
        this.resultData.forEach(r => {
          if (this.checkFlightVisibility(r)){
            tempResult.push(r)
          }
        })

        // CHECKING FILTER RESULT HERE to ensure user wont get any empty result
        // so if tempResults is empty, filter gets resetted automatically
        if (tempResult.length == 0){
          this.$alert("Mit dieser Auswahl wurde leider keine Flüge gefunden - der Filter wird zurückgesetzt")
          this.setFlightFilterValues(this.resultData)
          this.flightFilter = this.initialFilter
          // setting initial values for filteredResults
          this.filteredFlightResults = this._.cloneDeep(this.resultData).sort((a,b) => this.flightSortValue(a,b))
          console.log("shits empty yo")
          console.log(oldFilter)
          console.log(newFilter)
        }else{
          this.filteredFlightResults = tempResult.sort((a,b) => this.flightSortValue(a,b))
          //this.setFlightFilterValues(this.filteredFlightResults)
        }

      },
      deep: true
    }
  },
  data(){
    return {
      flightFilter: {
        departure_hour_in: [0, 24],
        departure_hour_out: [0, 24],
        flight_hours: 24,
        airport: [],
        carrier: [],
        cabin_type: [],
        airport_names: [],
        carrier_names: [],
        cabin_type_names: [],
        stops: -1,
        sortOption: 'flight_hours'
      },
      flightPlanLoading: false,
      apiFlightDetailsUrl: `${process.env.BASE_URL}/api/booking/${this.productId}/get_flight_details`,
      getServicesUrl: `${process.env.BASE_URL}/api/booking/${this.productId}/get_services`,
      minFlightHours: 99,
      maxFlightHours: 0,
      availableAirports: [],
      availableCarriers: [],
      initialFilter: {},
      cabinTypes: [],
      currentStep: 'flightResults',
      filteredFlightResults: [],
      sliderTimeFormatter: (v) => {
        const suffix = ':00'
        if (v.length == 1){
          return `0${v}${suffix}`
        }else if (v == 24){
          return "23:59"
        }else {
          return `${v}${suffix}`
        }
      },
      sliderHourFormatter: (v) => { return `${v} h` },
      sliderStopsFormatter: (v) => {
        if (v == 0){
          return "nur Non-Stop"
        }else if (v == 1){
          return `max. ${v} Stop`
        }else {
          return `max. ${v} Stops`
        }
      }
    }
  },
  computed: {
    anyFiltersSet(){
      // TODO write condition to check if any filters set
      return (this.filteredFlightResults.length < this.resultData.length)
    },
    sectionTitle(){
      if (this.filteredFlightResults.length > 0){
        return `Flugauswahl (${this.filteredFlightResults.length} Optionen)`
      } else {
        return "Flugauswahl wird geladen"
      }
    },
    sortedFlightResults(){

      var preferredFlights = []
      var nonPreferredFlights = []

      this.filteredFlightResults.forEach(r => {
        if (r.flight_meta.preferred){
          preferredFlights.push(r)
        }else{
          nonPreferredFlights.push(r)
        }
      })

      return preferredFlights.sort((a,b) => this.flightSortValue(a,b)).concat(
        nonPreferredFlights.sort((a,b) => this.flightSortValue(a,b))
      )
    }
  },
  methods: {
    proceedBooking(selected){

      var url = (this.isVpMode || true ? this.getServicesUrl : this.apiFlightDetailsUrl)

      var calcData = []
      this.result.calculation_data.forEach(data => {
        let d = this._.cloneDeep(data)
        d.from = selected.from
        d.to = selected.to
        d.duration = selected.duration
        d.flight_proposal_id = selected.flight_meta.flight_proposal_id
        calcData.push(d)
      })

      var params = {
        flight_type: selected.flight_meta.flight_type,
        flight_proposal_id: selected.flight_meta.flight_proposal_id,
        calculation_data: JSON.stringify(calcData),
        price: selected.price
      }
      this.$emit('next-started')
      this.gTrack('flightSelected')

      axios.get(url, { params: params })
      .then(response => {
        if (response.data.global.status == "NOK"){
          this.showGlobalErrorMessage(response.data.global.errors)
          this.$emit('failed')
        }else{
          this.$emit('next-loaded', response.data)
        }  
      })

    },

    showFlightPlan(selected){
      var params = {
        flight_type: selected.flight_meta.flight_type,
        flight_proposal_id: selected.flight_meta.flight_proposal_id,
        flight_plan_only: true
      }

      var reveal = new Foundation.Reveal($("#flight-plan-overlay.reveal"))
      this.flightPlanLoading = true
      $('#flight-plan-overlay .flight-plan-inner').html('')
      reveal.open()

      axios.get(this.apiFlightDetailsUrl, { params: params })
      .then(response => {
        $('#flight-plan-overlay .flight-plan-inner').html(response.data.flight_plan)

        this.flightPlanLoading = false
      })
    },

    checkFlightVisibility(flight){
      const f = this.flightFilter
      const m = flight.flight_meta
      var visible = true

      if (m.flight_hours > f.flight_hours){
        visible = false
      }

      if (m.departure_hour_in > f.departure_hour_in[1] || m.departure_hour_in < f.departure_hour_in[0]){
        visible = false
      }

      if (m.departure_hour_out > f.departure_hour_out[1] || m.departure_hour_out < f.departure_hour_out[0]){
        visible = false
      }

      m.carrier.forEach(c => {
        if (this.carrierAirportFilterSelected('carrier', c.code)){
          visible = false
        }
      })

      m.airports.forEach(a => {
        if (this.carrierAirportFilterSelected('airport', a.code)){
          visible = false
        }
      })

      if (this.carrierAirportFilterSelected('cabin_type', m.cabin_type)){
        visible = false
      }

      if (m.stops > f.stops){
        visible = false
      }

      return visible
    },

    flightSortValue(a,b){
      if (this.flightFilter.sortOption == 'flight_hours'){
        return a.flight_meta.flight_hours - b.flight_meta.flight_hours
      }else{
        return a.price - b.price
      }
    },

    setSortOption(opt){
      this.gTrack('sortFlights')
      this.flightFilter.sortOption = opt
    },
    resetFilter(){
      this.gTrack('resetFilter')
      this.flightFilter = this.initialFilter
      this.setFlightFilterValues(this.resultData, true)
    },
    setFlightFilterValues(res, resetFilter = true){

      // resetting values
      this.availableAirports = []
      this.availableCarriers = []
      this.cabinTypes = []

      res.forEach(r => {
        if (this.maxFlightHours < r.flight_meta.flight_hours){
          this.maxFlightHours = r.flight_meta.flight_hours
          if (resetFilter == true){
            this.flightFilter.flight_hours = this.maxFlightHours
          }

        }
        if (this.minFlightHours > r.flight_meta.flight_hours){
          this.minFlightHours = r.flight_meta.flight_hours
        }
        if (this.flightFilter.stops < r.flight_meta.stops){
          if (resetFilter == true){
            this.flightFilter.stops = r.flight_meta.stops
          }
        }
      })

      this.resultData.forEach(r => {
        r.flight_meta.carrier.forEach((logo) => {
          if (this.availableCarriers.findIndex(l => logo.code == l.code) == -1){
            this.availableCarriers.push(logo)
          }
        })
        r.flight_meta.airports.forEach((airport) => {
          if (this.availableAirports.findIndex(a => airport.code == a.code) == -1){
            this.availableAirports.push(airport)
          }
        })

        if (this.cabinTypes.findIndex(a => r.flight_meta.cabin_type == a) == -1){
          this.cabinTypes.push(r.flight_meta.cabin_type)
        }
      })

    },
    toggleFilterItem(id){
      $(`.filter--main__option:not(#${id}) .filter--main__option__dropdown`).slideUp()
      $(`.filter--main__option:not(#${id})`).removeClass('filter--main__open')

      $(`#${id} .filter--main__option__dropdown`).slideToggle()
      $(`#${id}.filter--main__option`).toggleClass('filter--main__open')
    },
    toggleCarrierAirportFilter(type, value, name){
      if (this.carrierAirportFilterSelected(type,value)){
        const i = this.flightFilter[type].findIndex(c => value == c)
        this.flightFilter[type].splice(i, 1)
        this.flightFilter[`${type}_names`].splice(i, 1)
      }else {
        this.flightFilter[type].push(value)
        this.flightFilter[`${type}_names`].push((name || value))
      }
    },
    carrierAirportFilterSelected(type, value){
      return this.flightFilter[type].findIndex(c => value == c) != -1
    },
    formattedFilterDisplayAirlineAirport(){
      var data = []
      const f = this.flightFilter

      if (f.carrier_names.length > 0){
        data.push(`ohne ${f.carrier_names}`)
      }

      if (f.airport_names.length > 0){
        data.push(`ohne ${f.airport_names}`)
      }

      if (data.length == 0){
        data.push("keine Einschränkung")
      }

      return data.join("<br />")
    },
    formattedFilterDisplayFlightTime(){
      var data = []
      const f = this.flightFilter

      if (f.departure_hour_out[0] != 0 || f.departure_hour_out[1] != 24){
        data.push(`Hin: ${this.sliderTimeFormatter(f.departure_hour_out[0])} - ${this.sliderTimeFormatter(f.departure_hour_out[1])}`)
      }

      if (f.departure_hour_in[0] != 0 || f.departure_hour_in[1] != 24){
        data.push(`Rück: ${this.sliderTimeFormatter(f.departure_hour_in[0])} - ${this.sliderTimeFormatter(f.departure_hour_in[1])}`)
      }
      if (f.flight_hours != this.maxFlightHours){
        data.push(`Max: ${this.sliderHourFormatter(f.flight_hours)}`)
      }

      if (data.length == 0){
        data.push("keine Einschränkung")
      }

      return data.join("<br />")
    },
    formattedFilterDisplayOptions(){
      var data = []
      const f = this.flightFilter
      if (f.cabin_type.length > 0){
        data.push(this.cabinTypes.filter(c => (this._.indexOf(f.cabin_type, c) == -1)))
      }else {
        data.push("alle Flugklassen")
      }
      data.push(this.sliderStopsFormatter(f.stops))
      return data.join(", ")
    }
  }
}
</script>

<style lang="scss" scoped>
  #flight-plan-overlay a { color: #000; }
</style>